<section
  class="more-information-section"
  *ngIf="
    last4ProductsDataSource?.length > 0 ||
    purchaseByCustomerProductsDataSource?.length > 0
  "
>
  <h2 data-cy="seller-detail-more-information-text">
    {{
      'i18n.productDetail.sellerDetailMoreInformation.moreInformation'
        | translate
    }}
  </h2>
  <mat-tab-group>
    <mat-tab label="Purchase History">
      <div class="tables-section">
        <div
          class="four-buys-section"
          *ngIf="last4ProductsDataSource?.length > 0"
        >
          <h4 data-cy="last-4-buys-text">
            {{
              'i18n.productDetail.sellerDetailMoreInformation.last4Buys'
                | translate
            }}
          </h4>
          <app-seller-detail-more-information-last-four-buys
            [last4ProductsDataSource]="last4ProductsDataSource"
          >
          </app-seller-detail-more-information-last-four-buys>
        </div>
        <div
          class="purchase-customer-section"
          *ngIf="purchaseByCustomerProductsDataSource?.length > 0"
        >
          <h4 data-cy="other-customer-last-buy-text">
            {{
              'i18n.productDetail.sellerDetailMoreInformation.otherCustomerLastBuy'
                | translate
            }}
          </h4>
          <app-usf-table
            [visibleColumns]="purchaseByCustomerDisplayColumns"
            [columnsConfig]="purchaseByCustomerProductsHeaderConfig"
            [dataSource]="purchaseByCustomerProductsDataSource"
            [mobileSummary]="true"
          ></app-usf-table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>
